module.exports = __webpack_public_path__ + "static/media/notify-logo-mb.b16956db.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/notify-logo-mb.png
 ** module id = 781
 ** module chunks = 0
 **/